import request from '@/request/request'

/**
 * 新建企业信息
 * @param {} parameter 
 * @returns 
 */
export function createCompany (parameter) {
  return request({
    url: '/e-find-company/company/createCompany',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取绑定企业清单
 * @param {} parameter 
 * @returns 
 */
export function listBindCompany () {
  return request({
    url: '/e-find-company/company/listBindCompany',
    method: 'get',
  })
}

/**
 * 获取绑定企业清单
 * @param {} parameter 
 * @returns 
 */
export function getCompanyDetail () {
  return request({
    url: '/e-find-company/company/getCompanyDetail',
    method: 'get',
  })
}

/**
 * 更新企业信息
 * @param {} parameter 
 * @returns 
 */
export function updateCompany (parameter) {
  return request({
    url: '/e-find-company/company/updateCompany',
    method: 'post',
    data: parameter
  })
}

/**
 * 更新企业授权信息
 * @param {} parameter 
 * @returns 
 */
export function updateAuthorizationDocument (parameter) {
  return request({
    url: '/e-find-company/company/updateAuthorizationDocument',
    method: 'post',
    data: parameter
  })
}

/**
 * 更新企业授权信息
 * @param {} parameter 
 * @returns 
 */
export function updateSwitchPassword (parameter) {
  return request({
    url: '/e-find-company/company/updateSwitchPassword',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证权利人信息
 * @param {} parameter 
 * @returns 
 */
export function getObligeeDetail () {
  return request({
    url: '/e-find-company/company/getObligeeDetail',
    method: 'get',
  })
}
